// extracted by mini-css-extract-plugin
export default {"SwipeableContainer":"OccasionsCarousel_SwipeableContainer__JSH4E","CarouseContent":"OccasionsCarousel_CarouseContent__P0x5Q"};